import { Component, OnInit } from '@angular/core';
import { CellSetting } from '@app/layout/cell-setting';
import { CellValueChangedArgs } from '@app/layout/cell-value-changed-args';
import { LayoutService } from '@app/layout/layout.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-return-wizard',
  templateUrl: './return-wizard.component.html',
  styleUrls: ['./return-wizard.component.less'],
})
export class ReturnWizardComponent implements OnInit {
  generatingRes = 0;
  generatingResTitle = '';
  generatingResMessage = '';
  openItemsTableCols: any[];
  dataTable: { name: string; dataset: any[] };
  cellSettings: CellSetting[] = [];
  treeViewData: any[];

  resultTableCols: any[];
  resultDataTable: { name: string; dataset: any[] };
  resultCellSettings: CellSetting[] = [];

  filterFields: any[];

  openDocumentsIsLoading = false;
  generatingIsLoading = false;

  constructor(
    private message: NzMessageService,
    private layoutService: LayoutService
  ) {
    this.layoutService.cellValueChanged.subscribe(
      (args: CellValueChangedArgs) => {
        if (
          args.name === 'returnWizard' &&
          args.column.Name === 'U_ITM_RETURNED_QTY'
        ) {
          const row = args.row;
          const openQty = Number(args.dataset[row]['OpenQty']);
          let releasedQty = Number(args.dataset[row]['U_ITM_RETURNED_QTY']);
          if (releasedQty > openQty) {
            this.message.error(
              this.layoutService.translate(
                `The returned quantity is more than the open quantity`
              )
            );
            args.dataset[row]['U_ITM_RETURNED_QTY'] = '0';
          }

          releasedQty = Number(args.dataset[row]['U_ITM_RETURNED_QTY']);
          if (releasedQty !== 0) {
            args.dataset[row]['SELECTED'] = true;
          } else {
            args.dataset[row]['SELECTED'] = false;
          }

          const treeType = args.dataset[row]['TreeType'];
          if (releasedQty !== 0 && treeType === 'S') {
            for (let i = row + 1; i < args.dataset.length; i++) {
              const row = args.dataset[i];
              let innerTreeType = row['TreeType'];
              if (innerTreeType !== 'I') {
                break;
              }
              this.setCellEditable(i, 'U_ITM_RETURNED_QTY', false);
              this.setCellEditable(i, 'U_ITM_REASON', false);
            }
          } else if (releasedQty === 0 && treeType === 'S') {
            for (let i = row + 1; i < args.dataset.length; i++) {
              const row = args.dataset[i];
              let innerTreeType = row['TreeType'];
              if (innerTreeType !== 'I') {
                break;
              }
              this.setCellEditable(i, 'U_ITM_RETURNED_QTY', true);
              this.setCellEditable(i, 'U_ITM_REASON', true);
            }
          } else if (releasedQty !== 0 && treeType === 'I') {
            for (let i = row - 1; i >= 0; i--) {
              const row = args.dataset[i];
              let innerTreeType = row['TreeType'];
              if (innerTreeType === 'S') {
                this.setCellEditable(i, 'U_ITM_RETURNED_QTY', false);
                this.setCellEditable(i, 'U_ITM_REASON', false);
                break;
              }
            }
          } else if (releasedQty === 0 && treeType === 'I') {
            for (let i = row - 1; i >= 0; i--) {
              const row = args.dataset[i];
              let innerTreeType = row['TreeType'];
              if (innerTreeType === 'S') {
                let parentShouldDisabled = false;
                for (let j = i + 1; j < args.dataset.length; j++) {
                  const childRow = args.dataset[j];
                  let innerTreeType = childRow['TreeType'];
                  if (innerTreeType !== 'I') {
                    break;
                  }

                  let childReleasedQty = Number(childRow['U_ITM_RETURNED_QTY']);
                  if(childReleasedQty > 0){
                    parentShouldDisabled = true;
                    break;
                  }
                }

                this.setCellEditable(i, 'U_ITM_RETURNED_QTY', !parentShouldDisabled);
                this.setCellEditable(i, 'U_ITM_REASON', !parentShouldDisabled);
                break;
              }
            }
          }
        }
      }
    );
  }

  setCellEditable(row: number, column: string, editable: boolean): void {
    var rowIndex = this.cellSettings.findIndex(
      (d) => d.row === row && d.column === column
    );
    if (rowIndex === -1) {
      this.cellSettings.push({
        row: row,
        column: column,
        settings: { readonly: !editable },
      });
    } else {
      this.cellSettings[rowIndex].settings.readonly = !editable;
    }
  }

  ngOnInit(): void {
    this.openDocumentsIsLoading = false;
    this.generatingIsLoading = false;
    this.cellSettings = [];

    this.generatingRes = 0;
    this.generatingResTitle = '';
    this.generatingResMessage = '';

    this.resultCellSettings = [];

    this.getReturnWizardFilterFields();
    this.getItemsToReturnCols();
    this.getResultCols();

    this.dataTable = {
      name: '',
      dataset: [],
    };
    this.dataTable.name = 'returnWizard';

    this.resultDataTable = {
      name: '',
      dataset: [],
    };
    this.resultDataTable.name = 'generatingResult';
  }

  getItemsToReturnCols(): void {
    this.layoutService.getSectionTableColumns(50080).subscribe((d: any) => {
      this.openItemsTableCols = JSON.parse(d.cols);
    });
  }

  getResultCols(): void {
    this.layoutService.getSectionTableColumns(50082).subscribe((d: any) => {
      this.resultTableCols = JSON.parse(d.cols);
    });
  }

  getReturnWizardFilterFields(): void {
    this.layoutService.getFilterFields(50081).subscribe((d: any) => {
      console.log({ FilterFields: d.Data.fields });
      this.filterFields = d.Data.fields;
    });
  }

  getItemsToReturn(): void {
    this.openDocumentsIsLoading = true;
    this.generatingRes = 0;

    const filterData: { [key: string]: any } = {};
    this.filterFields.forEach((filterField) => {
      if (
        filterField.Value != null &&
        filterField.Value !== undefined &&
        filterField.Value !== ''
      ) {
        filterData[filterField.FieldName] = filterField.Value;
      } else {
        filterData[filterField.FieldName] = '';
      }
    });

    this.layoutService
      .executeQuery(80145, filterData)
      .subscribe((result: any[]) => {
        this.openDocumentsIsLoading = false;
        this.dataTable.dataset = result;
        this.cellSettings = [];

        this.treeViewData = this.convertToTreeView(result);
      });
  }

  generateReturns(): void {
    this.generatingIsLoading = true;
    this.resultDataTable = {
      name: '',
      dataset: [],
    };
    this.resultDataTable.name = 'generatingResult';
    this.resultCellSettings = [];
    this.generatingRes = 0;

    let rowsToProcess: any[] = [];
    let thereIsError: boolean = false;
    this.dataTable.dataset.forEach((row) => {
      let checked = row['U_ITM_RETURNED_QTY'] > 0 ? true : false;
      let reasonCodeIsSelected =
        row['U_ITM_REASON'] != null &&
        row['U_ITM_REASON'] !== undefined &&
        row['U_ITM_REASON'] !== '';
      if (
        checked &&
        row.hasOwnProperty('U_ITM_REASON') &&
        !reasonCodeIsSelected
      ) {
        this.message.error(
          'you should set the reason code for all returned items'
        );
        this.generatingIsLoading = false;
        return;
      }
      if (checked) {
        let rowToProcess = {
          DocEntry: Number(row['DocEntry']),
          DocNum: Number(row['DocNum']),
          CardCode: row['CardCode'],
          CardName: row['CardName'],
          ItemCode: row['ItemCode'],
          LineNum: Number(row['LineNum']),
          DocType: Number(row['DocType']),
          Quantity: Number(row['U_ITM_RETURNED_QTY']),
          TreeType: row['TreeType'],
          Reason: row['U_ITM_REASON'],
        };
        rowsToProcess.push(rowToProcess);
      }
    });

    if (thereIsError || rowsToProcess.length === 0) {
      this.message.info('There is no data to process');
      this.generatingIsLoading = false;
      return;
    }
    console.log({ rowsToProcess: rowsToProcess });

    const jsonToPush = JSON.stringify(rowsToProcess);
    const actionCode = 'GenerateReturns';

    this.layoutService
      .pushDataToBackend(jsonToPush, actionCode, jsonToPush)
      .subscribe((d: any) => {
        let result = d;
        console.log({ result: result });
        if (result.Has_Error) {
          this.generatingRes = 1;
          this.generatingResTitle = 'Generating returns failed';
          this.generatingResMessage = result.Error_Message;
        } else {
          let res = JSON.parse(result.Resault_Value);
          if (!res.Result.Success) {
            this.generatingRes = 1;
            this.generatingResTitle = 'Generating returns failed';
            this.generatingResMessage = res.Result.Msg;
          } else {
            this.generatingRes = 2;
            this.generatingResTitle = 'Generating returns result(s)';
            this.resultDataTable.dataset = JSON.parse(res.Result.Msg);
            this.resultCellSettings = [];
          }
        }

        this.generatingIsLoading = false;
      });
  }

  convertToTreeView(data) {
    const tree = [];

    const groupedData = data.reduce((acc, item) => {
      const key = item.DocEntry;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});

    for (const key in groupedData) {
      const entries = groupedData[key];

      let parentNode = null;
      let children = [];

      entries.forEach((entry) => {
        if (entry.TreeType === 'S' || entry.TreeType === 'N') {
          parentNode = {
            data: entry,
            children: [],
          };
        } else if (entry.TreeType === 'I') {
          children.push({
            data: entry,
          });
        }
      });

      if (parentNode) {
        parentNode.children = children;
        tree.push(parentNode);
      } else {
        tree.push(...children);
      }
    }
    return tree;
  }

  formatterNumber(value: number): string {
    if (value == null || value == 0 || Number.isNaN(Number(value))) return '';
    return `${Number(value).toFixed(0).toString()}`;
  }
}
